import React, { useState } from "react";
const Forms = () => {
  const [fullName, setFullName] = useState({
    firstName: "",
    lastName: "",
  });

  const handleInput = (event) => {
    console.log(event.target.name)
    if(event.target.name === 'first_name'){
      setFullName((prev)=>{
        return{
          firstName: event.target.value,
          lastName: prev.lastName
        }
      })
    }
    else if(event.target.name === 'last_name'){
      setFullName((prev)=>{
        return{
          firstName: prev.firstName,
          lastName: event.target.value
        }
      })
    }

  };

  const handleSubmit = (event) => {
    event.preventDefault();
    alert(fullName.firstName+ " "
    + fullName.lastName)
 
  };

  return (
    <div className="form_container">
      {/* <form onSubmit={handleSubmit}> */}
        <input 
        type="text" 
        value={fullName.firstName} 
        onChange={handleInput} 
        name='first_name'
        placeholder="First name"
        />
        <input 
        type="text" 
        value={fullName.lastName} 
        onChange={handleInput}
        name='last_name'
        placeholder="Last name"
         />

        <div>
          <button type="button" class="btn btn-primary" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      {/* </form> */}
    </div>
  );
};

export default Forms;
